import { Component, Input, SimpleChanges } from '@angular/core';
import { Image } from '@ks89/angular-modal-gallery';
import { HelpFileTypes } from 'src/app/core/api/models';

@Component({
    selector: 'app-show-images',
    templateUrl: './show-images.component.html',
    styleUrls: ['./show-images.component.scss'],
    standalone: false
})
export class ShowImagesComponent {
  //#region properties

  @Input('src') input_src: string;
  @Input('imgHeight') input_imgHeight: string = '108px';
  @Input('imgWidth') input_imgWidth: string = '100%';
  @Input('imgStyle') input_style: string;
  @Input() imageClass: string;
  @Input() imageType: HelpFileTypes;
  images: Image[] = [];
  isValidImage: boolean = true;

  get HelpFileTypes() {
    return HelpFileTypes;
  }

  //#endregion

  onImageLoad() {
    this.isValidImage = true;
  }

  onImageError() {
    this.isValidImage = false;
    this.input_src = '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['input_src'] && this.input_src) {
      this.images = [];
      this.images.push(
        new Image(0, {
          img: this.input_src,
          extUrl: '',
        })
      );
    }
  }
}
